import { ValidationResult, useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateCloudSubtitleAssetLanguageResponse } from "../../../../../../../../common/api/master-api/assets/details/UpdateCloudSubtitleAssetLanguageResponse";
import { ValidateCloudSubtitleAssetLanguageRequest } from "../../../../../../../../common/api/master-api/assets/details/ValidateCloudSubtitleAssetLanguageRequest";
import { useAssetsApi } from "../../../../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../../../common/CloudAssetQueryKey";

export interface UseEditCloudAsset {
    validateCloudSubtitleAssetLanguage: SprintMutationResult<
        ValidateCloudSubtitleAssetLanguageRequest,
        ValidationResult
    >;
    updateCloudSubtitleAssetLanguage: SprintMutationResult<
        ValidateCloudSubtitleAssetLanguageRequest,
        UpdateCloudSubtitleAssetLanguageResponse
    >;
}

export const useEditCloudSubtitleAssetLanguage = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseEditCloudAsset => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const validateCloudSubtitleAssetLanguage = useSprintMutation<
        ValidateCloudSubtitleAssetLanguageRequest,
        ValidationResult
    >({
        mutationFn: async ({ assetId, subtitleLanguageId }): Promise<ValidationResult> => {
            if (!assetId) {
                throw new Error("Asset ID is required to validate subtitle language.");
            }

            return assetsApi.validateCloudSubtitleAssetLanguage({ assetId, subtitleLanguageId });
        }
    });

    const updateCloudSubtitleAssetLanguage = useSprintMutation<
        ValidateCloudSubtitleAssetLanguageRequest,
        UpdateCloudSubtitleAssetLanguageResponse
    >({
        mutationFn: async ({ assetId, subtitleLanguageId }: ValidateCloudSubtitleAssetLanguageRequest) => {
            if (!assetId) {
                throw new Error("Asset ID is required to update subtitle language.");
            }

            return assetsApi.updateCloudSubtitleAssetLanguage({ assetId, subtitleLanguageId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.CloudAssetDetails, invalidationKey]
            });
        }
    });

    return {
        validateCloudSubtitleAssetLanguage,
        updateCloudSubtitleAssetLanguage
    };
};
